import { Prisma } from "@prisma/client";
import { NORMALIZED_EMAIL_FIELDS } from "./constants";
import { normalizeEmailArgs } from "./utils";

/**
 * Stores and matches every email in `NORMALIZED_EMAIL_FIELDS` lowercased and
 * trimmed, so no caller has to remember to. Older rows saved with capitals
 * ("Nholloway5@…") locked people out of sign-in and password reset because
 * each lookup normalized, or didn't, on its own.
 *
 * Adds no models, fields or methods.
 */
export const createEmailNormalizationExtension = () =>
  Prisma.defineExtension({
    name: "email-normalization",
    query: {
      $allModels: {
        $allOperations({ model, args, query }) {
          const fields = NORMALIZED_EMAIL_FIELDS[model as Prisma.ModelName];
          if (!fields) {
            return query(args);
          }
          // Typed loosely on purpose: `args` is a union over every model and
          // operation, too large for TypeScript to carry through a helper.
          const run = query as unknown as (args: unknown) => Promise<unknown>;
          return run(normalizeEmailArgs(args as unknown, fields));
        },
      },
    },
  });
